import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as api from "../api";
import { createApiThunk } from '../features/helpers';

export const createContent = createAsyncThunk(
  "content/createContent",
  async ({ tourID, createContentData, toast, navigate }, { rejectWithValue }) => {
    try {
      const response = await api.createContent(createContentData, tourID);
      toast.success("Índice adicionado com Sucesso");
      navigate(`/tour/${tourID}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getContentById = createApiThunk('content/getContentById', api.getContent);

const contentSlice = createSlice({
  name: "content",
  initialState: {
    content: {},
    contents: [],
    userTours: [],
    error: "",
    loading: false,
  },
  extraReducers: {
    [createContent.pending]: (state, action) => {
      state.loading = true;
    },
    [createContent.fulfilled]: (state, action) => {
      state.loading = false;
      const {
        arg: { tourID },
      } = action.meta;
      if (tourID){
        state.contents = state.contents.map((item) =>
          item._id === tourID ? action.payload : item
        );
      };
    },
    [createContent.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    },
    [getContentById.pending]: (state, action) => {
      state.loading = true;
    },
    [getContentById.fulfilled]: (state, action) => {
      state.loading = false;
      console.log('payload: ', action.payload.content);
      state.contents = action.payload.content;
    },
    [getContentById.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    },
  },
});

export default contentSlice.reducer;
